<template>
  <vs-radio
    :class="{
      'radio': true,
      'checked': isChecked()
    }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </vs-radio>
</template>

<script>
export default {
  name: 'RadioButton',
  methods: {
    isChecked() {
      return this.$attrs['value'] === this.$attrs['vs-value']
    }
  }
}
</script>

<style lang="scss" scoped>
.radio {
  @apply bg-secondary-accent;
  @apply relative;
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply rounded-xl;
  @apply px-3;
  @apply py-1;
  -webkit-transition: background-color .25s ease;
  transition: background-color .25s ease;
  --bg-opacity: 0.36;

  /deep/.vs-radio {
    @apply h-4;
    @apply w-4;
    @apply rounded-full;

    &--input {
      @apply w-5;
    }

    &--borde {
      @apply bg-white;
      @apply border #{!important};
      @apply border-secondary #{!important};
      @apply rounded-full;
      @apply cursor-pointer;
    }

    &--circle {
      @apply bg-white #{!important};
      @apply rounded-full;
      @apply opacity-0;
      -webkit-box-shadow: 0 0 0 3px #FF7F57 inset !important;
      box-shadow: 0 0 0 3px #FF7F57 inset !important;
    }

    &--label {
      @apply ml-3;
      @apply font-normal;
    }
  }

  &.checked {
    @apply bg-secondary;
    @apply text-white;
    --bg-opacity: 1;

    /deep/.vs-radio{
      @apply z-10;

      &--borde {
        @apply border-0.5;
        @apply border-white;
        @apply z-10;
      }

      &--circle {
        @apply border-0.5;
        @apply border-white;
        @apply z-0;
      }

      &--label {
        @apply font-semibold;
      }
    }
  }
}
</style>
